<template>
	<div class="about">
		<img style="width: 100%;" class="wow fadeIn" src="../../assets/cinemaBg.jpg" />
		<div class="contentinfo">
			<div class="demo1">
				<div class="mainArea flexBtw">
					<div class="demo1Left">
						<div class="a">为存量影院打开票房增长空间</div>
						<div class="flexBtw b">
							<dl>
								<dt>全国已建剧院</dt>
								<dd>128座</dd>
							</dl>
							<dl>
								<dt>分布城市</dt>
								<dd>64个</dd>
							</dl>
						</div>
						<div class="c" @click.stop="dialogTableVisible=!dialogTableVisible">
							4个一线城市、14个新一线城市、16个二线城市、20个三线城市、10个四线城市<i class="el-icon-warning-outline" style="margin-left: 5px;color: #FF5500;"></i>
						</div>
					</div>
					<img class="d" src="../../assets/china.png"/>
				</div>
				
			</div>
			<div class="mainArea demo2">
				<img src="../../assets/cinema_2.jpg"/>
				<div class="demo2Inner">
					<h2>为优质内容提供全新传播方式</h2>
				</div>
			</div>
			<div class="demo3">
				<div class="mainArea">
					<ImageCarousel :images="imageList" :fixed-height="400" :initial-speed="6" :gap="15" />					
				</div>				
				<img class="bgImg" src="../../assets/cinema_3.png" alt="" />
			</div>
		</div>
		<el-dialog width="80%"  :visible.sync="dialogTableVisible">
			<div  class="cardBox">
				<b>4个一线城市：</b>北京、上海、广州、深圳<br>
				<b>14个新一线城市：</b>长沙、南京、苏州、武汉、天津、西安、重庆、佛山、东莞、青岛、成都、杭州、郑州、宁波<br>
				<b>16个二线城市：</b>南昌、福州、厦门、徐州、南宁、常州、无锡、长春、济南、太原、嘉兴、金华、南通、中山、沈阳、珠海<br>
				<b>20个三线城市：</b>湖州、台州、汕头、海口、镇江、邯郸、南阳、襄阳、株洲、扬州、盐城、九江、赣州、鞍山、锦州、银川、西宁、临沂、咸阳、泸州<br>
				<b>10个四线城市：</b>百色、三河、麻城、抚州、大同、孝感、射阳、秦皇岛、新昌、乐清
			</div>					  
		</el-dialog>
	</div>
</template>
<script>	
	import { WOW } from 'wowjs'
	import ImageCarousel from '../../compenents/ImageCarousel.vue'
	export default {
		name: 'Home',
		components:{
			ImageCarousel,
		},
		data() {
			return {
				dialogTableVisible:false,
				imageList:[{
					src:'https://platform.txpc.cn/pg-txpc-img/cinema/1.jpg'
				},{
					src:'https://platform.txpc.cn/pg-txpc-img/cinema/2.jpg'
				},{
					src:'https://platform.txpc.cn/pg-txpc-img/cinema/3.jpg'
				},{
					src:'https://platform.txpc.cn/pg-txpc-img/cinema/4.jpg'
				},{
					src:'https://platform.txpc.cn/pg-txpc-img/cinema/5.jpg'
				},{
					src:'https://platform.txpc.cn/pg-txpc-img/cinema/6.jpg'
				}]
			}
		},
		created() {
			let isM=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if(isM){
				this.$router.push({ path: '/mobile/cinema'});
			}
		},
		mounted() {
			this.$nextTick(() => {
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		},
		methods: {
			
		},
	}
</script>
<style lang="less" scoped>
	.about{
		background: #000510;
	}
	.contentinfo{
		position: relative;
		border-radius: 5px;
		z-index: 2;
		width: 100%;
	}
	.cardBox{
		text-align: left;
		font-size: 20px;
		color: #555;
		line-height: 50px;
		b{
			color: #333;
		}
	}
	.demo1{
		background: url('../../assets/cinema_1.jpg') center;
		background-size: 100% 100%;
		padding-top: 100px;
		padding-bottom: 100px;
		.d{
			flex: 1;
		}
		.demo1Left{
			text-align: left;	
			flex: 1;
			.a{
				text-align: left;
				color: #F50;
				font-size: 42px;
				font-weight: 600;
				line-height: 57.6px; /* 137.143% */
			}
			.b{
				margin-top: 50px;
				dl{
					flex: 1;
					dt{
						font-size: 28px;
						letter-spacing: 1.4px;
						margin-bottom: 20px;
					}
					dd{
						font-size: 48px;
					}
				}
			}
			.c{
				width: 385px;
				margin-top: 100px;
				padding-top: 10px;
				border-top: 0.5px solid #fff;
				font-size: 16px;
				line-height: 30px;
				cursor: pointer;
			}
		}
	}
	.demo2{
		position: relative;
		img{
			width: 100%;
			height: auto;
		}
		.demo2Inner{
			width: 100%;
			position: absolute;
			top:100px;
			text-align: center;
			z-index: 2;
			color:#fff;
			h2{
				color: #FFF;
				font-family: "PingFang SC";
				font-size: 42px;
				font-style: normal;
				font-weight: 600;
				line-height: 57.6px; /* 137.143% */
				margin-bottom: 40px;
			}
			p{
				color: #FFF;
				width: 700px;	
				margin: 0 auto;
				font-size: 16px;
				line-height: 30px; /* 187.5% */
			}
		}
	}
	.bgImg{
		width: 100%;
		margin-top: -50px;
	}
	.demo3{
		margin-top: 10px;
	}
	
	.abBox{
		background: #FF5500;
		text-align: left;
		color: #fff;
		position: absolute;
		z-index: 999;
		right: 20px;
		top:40px;
		padding: 40px;
		width: 300px;
		height: 420px;
		font-size: 14px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		.title{
			font-size: 24px;
		}
		dt{
			font-weight: bold;
			margin-bottom: 5px;
			margin-top: 5px;
		}
		dd{
			font-weight: 400;
			line-height: 20px;
			font-size: 12px;
			opacity: 0.8;
		}
	}
</style>